export enum InspectionOriginEnum {
  CURBO = 'CURBO',
  DEALER = 'DEALER',
  FTC = 'FTC',
  SMC = 'SMC',
  UNKNOWN = 'UNKNOWN',
}
